import React, { PropTypes } from 'react';

const Luft = ({value}) => {
    const marginal = (typeof value === 'string' && value) || (value && value.marginal) || "40px";
      const style = require('./Luft.scss');
      return (
        <div className={style.wrapper}>
          
          <hr style={{marginTop: parseInt(marginal)/2 + "px", marginBottom: parseInt(marginal)/2 + "px", marginLeft:"0", marginRight:"0", borderWidth:"0px"}}/>
          </div>
      );
};

export default Luft;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Luft/Luft.js
 **/